"use client";

import { useEffect, useState } from "react";

export function useIsMobileOrTablet() {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(max-width: 1023px)"); // Tailwind < lg

    const handleChange = () => {
      setIsMobileOrTablet(media.matches);
    };

    handleChange(); // run on mount

    media.addEventListener("change", handleChange);

    return () => media.removeEventListener("change", handleChange);
  }, []);

  return isMobileOrTablet;
}
